import { EventChannel, EventSeverity, EventSeverityLabels } from '@mojility/core-es6';

const INFO_DISMISS_TIMEOUT = 15000;

class EventsNotifier {
  constructor($scope, eventsService) {
    $scope.$ctrl = this;
    this.$scope = $scope;
    this.eventsService = eventsService;

    eventsService.subscribe(EventChannel.System, (event) => {
      if (event.severity > EventSeverity.Warning) {
        setTimeout(() => {
          eventsService.acknowledge(event);
          $scope.$digest();
        }, INFO_DISMISS_TIMEOUT);
      }
      $scope.$digest();
    });
  }

  get events() {
    return this.eventsService.eventsFor(EventChannel.System);
  }

  dismiss(event) {
    this.eventsService.acknowledge(event);
  }

  eventClassNames(event) {
    let classes = [];
    classes.push(event.type);
    classes.push(EventSeverityLabels[event.severity]);
    return classes.join(' ');
  }

  eventMetadata(event) {
    return EventSeverityLabels[event.severity];
  }
}

export default {
  name: 'eventsNotifier',
  obj: {
    controller: EventsNotifier,
    templateUrl: 'components/events_notifier.html',
    bindings: {}
  },
  deps: []
}